import React from 'react';
import { createPortal } from 'react-dom';
import { Modal } from '../ui/Modal';

/**
 * "Recent requests", shown on demand instead of inline: the list can run to
 * its full length and would push the rest of the MCP page down. Portalled to
 * document.body because this page renders inside the Settings modal — an
 * in-place Modal would stack inside it rather than over it.
 */
/** `at` is Unix ms (mcp/activity.rs); shown in the app's locale. */
function formatTime(ms) {
  return Number.isFinite(ms) && ms > 0 ? new Date(ms).toLocaleTimeString() : '';
}

export default function McpActivityModal({ t, isOpen, onClose, activity }) {
  if (!isOpen) return null;
  return createPortal(
    <Modal isOpen onClose={onClose} title={t('mcp.activityTitle')} subtitle={t('mcp.activityDesc')} size="lg">
      {activity.length === 0 ? (
        <div className="settings-row-desc">{t('mcp.activityEmpty')}</div>
      ) : (
        <ul className="mcp-activity mcp-activity--modal panel-scroll" aria-label={t('mcp.activityTitle')}>
          {activity.map((entry, i) => (
            <li key={`${entry.at}-${i}`} className="mcp-activity-row">
              <span className="mcp-activity-time">{formatTime(entry.at)}</span>
              <span className="mcp-activity-tool">{entry.tool}</span>
              <span className="mcp-activity-verdict">
                {entry.allowed ? t('mcp.activityAllowed') : t('mcp.activityDenied')}
                {entry.reason ? ` · ${entry.reason}` : ''}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Modal>,
    document.body,
  );
}
